import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaggingTextAreaComponent } from './tagging-text-area.component';
import { MentionModule } from 'angular-mentions';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';

@NgModule({
  declarations: [TaggingTextAreaComponent],
  imports: [
    CommonModule,
    MentionModule,
    ReactiveFormsModule,
    TranslocoDirective
  ],
  exports: [TaggingTextAreaComponent],
})
export class TaggingTextAreaModule {}
